export default {
  imgSrc: "",

  //评价类型定义 用于点赞,评论,举报 与后台对应
  evaluateType: {
    //评论
    COMMENT: 0,
    //主题
    SUBJECT: 1,
    //课程
    COURSE: 2,
    //转发
    FORWARD: 3
  },

  // 判断是否是resadmin使用 目前使用到的业务： 通知模块
  isResAdmin: "resadmin",
  noticeMessage: "<div>尊敬的各位老师：</div>\n" +
  "<div class=\"msg\">\n" +
  "为提高己简平台的处理能力，提供更快速便捷的服务，我公司计划于\n" +
  "<span class=\"text-blob\">2022年04月13日21:00至04月14日8:00进行系统停机维护，期间己简平台教师端、己简课堂学生端、己简H5将停止提供服务，</span>由此给您带来的不便，敬请谅解。\n" +
  "</div>\n" +
  "<div class=\"msg-footer\">\n" +
  "<div>大连爱丁云教育</div>\n" +
  "<div>2020年04月07日</div>\n" +
  "</div>",
};



// WEBPACK FOOTER //
// ./src/constant/constant.js